import React from "react";
import MuiDrawer from "@mui/material/Drawer";
import useMediaQuery from "@mui/material/useMediaQuery";

// Keep MUI's timing, focus handling and backdrop; also animate lazy-mounted drawers.
const Drawer = React.forwardRef(function Drawer(
  { SlideProps, transitionDuration, ...props },
  ref
) {
  const reduceMotion = useMediaQuery("(prefers-reduced-motion: reduce)");

  return (
    <MuiDrawer
      {...props}
      ref={ref}
      transitionDuration={reduceMotion ? 0 : transitionDuration}
      SlideProps={{
        appear: true,
        ...SlideProps,
        ...(reduceMotion ? { timeout: 0 } : {}),
      }}
    />
  );
});

export default Drawer;
